import React from 'react';
import { cancellationPeriodTypeValue } from '~constants/property-field-options';

export const longtailCancellationPeriod = {
  BEFORE_MOVE_IN_CALENDAR_DAYS_0: 'BEFORE_MOVE_IN_CALENDAR_DAYS_0',
  BEFORE_MOVE_IN_CALENDAR_DAYS_7: 'BEFORE_MOVE_IN_CALENDAR_DAYS_7',
  BEFORE_MOVE_IN_CALENDAR_DAYS_14: 'BEFORE_MOVE_IN_CALENDAR_DAYS_14',
  BEFORE_MOVE_IN_CALENDAR_DAYS_28: 'BEFORE_MOVE_IN_CALENDAR_DAYS_28',
  BEFORE_MOVE_IN_CALENDAR_DAYS_30: 'BEFORE_MOVE_IN_CALENDAR_DAYS_30',
  BEFORE_MOVE_IN_CALENDAR_DAYS_60: 'BEFORE_MOVE_IN_CALENDAR_DAYS_60',
  BEFORE_MOVE_IN_CALENDAR_DAYS_90: 'BEFORE_MOVE_IN_CALENDAR_DAYS_90',
  NON_REFUNDABLE: 'NON_REFUNDABLE',
};

export const getFreeCancellationPeriodText = (type, value, t) => {
  if (type === cancellationPeriodTypeValue.BEFORE_MOVE_IN) {
    if (value === 1) {
      return (
        <>
          <span className="longtail-cancellation-policy__header-title-day">
            {`${value} ${t(
              'cms:cms.properties.edit.detail.cancellation_period.before_calendar_day',
            )}`}
          </span>
          <span>{` `}</span>
          <span>
            {t('cms:cms.properties.edit.detail.cancellation_period.before_move_in_suffix')}
          </span>
        </>
      );
    }
    if (value > 1) {
      return (
        <>
          <span className="longtail-cancellation-policy__header-title-day">
            {`${value} ${t(
              'cms:cms.properties.edit.detail.cancellation_period.before_calendar_days',
            )}`}
          </span>
          <span>{` `}</span>
          <span>
            {t('cms:cms.properties.edit.detail.cancellation_period.before_move_in_suffix')}
          </span>
        </>
      );
    }
  }
  if (type === cancellationPeriodTypeValue.AFTER_BOOKING_CONFIRMED) {
    if (value === 1) {
      return (
        <>
          <span className="longtail-cancellation-policy__header-title-day">
            {`${value} ${t(
              'cms:cms.properties.edit.detail.cancellation_period.before_calendar_day',
            )}`}
          </span>
          <span>{` `}</span>
          <span>
            {t('cms:cms.properties.edit.detail.cancellation_period.after_confirm_suffix')}
          </span>
        </>
      );
    }
    if (value > 1) {
      return (
        <>
          <span className="longtail-cancellation-policy__header-title-day">
            {`${value} ${t(
              'cms:cms.properties.edit.detail.cancellation_period.before_calendar_days',
            )}`}
          </span>
          <span>{` `}</span>
          <span>
            {t('cms:cms.properties.edit.detail.cancellation_period.after_confirm_suffix')}
          </span>
        </>
      );
    }
  }
  if (type === cancellationPeriodTypeValue.NON_REFUNDABLE) {
    return t('cms:cms.free_cancellation_policy.booking_paid.title');
  }
  return '';
};

export const withInRules = {
  rule_1: {
    icon: 'check',
    text: 'cms:cms.free_cancellation_policy.rule_1',
  },
  rule_2: {
    icon: 'check',
    text: 'cms:cms.free_cancellation_policy.rule_2',
  },
  rule_3: {
    icon: 'close',
    text: 'cms:cms.free_cancellation_policy.rule_3',
    tip: 'cms:cms.free_cancellation_policy.rule_3.tips',
  },
};

export const allCancellationTrans = {
  NON_REFUNDABLE: {
    withIn: null,
    withOut: {
      title: 'cms:cms.cancellation_policy.card.with_out.title',
      desc: 'cms:cms.cancellation_policy.card.with_out.desc',
    },
  },
  UNTIL_MOVE_IN_DAY: {
    withIn: {
      title: 'cms:cms.cancellation_policy.card.with_in.title',
      desc: 'cms:cms.cancellation_policy.card.with_in.check_in.desc',
      hasRules: true,
    },
    withOut: {
      title: 'cms:cms.cancellation_policy.card.with_out.title',
      desc: 'cms:cms.cancellation_policy.card.with_out.desc',
    },
  },
  BEFORE_MOVE_IN: {
    withIn: {
      title: 'cms:cms.cancellation_policy.card.with_in.title',
      desc: 'cms:cms.cancellation_policy.card.with_in.desc',
      hasRules: true,
    },
    withOut: {
      title: 'cms:cms.cancellation_policy.card.with_out.title',
      desc: 'cms:cms.cancellation_policy.card.with_out.desc',
    },
  },
  AFTER_BOOKING_CONFIRMED: {
    withIn: {
      title: 'cms:cms.cancellation_policy.card.with_in.title',
      desc: 'cms:cms.cancellation_policy.card.with_in.desc',
      hasRules: true,
    },
    withOut: {
      title: 'cms:cms.cancellation_policy.card.with_out.title',
      desc: 'cms:cms.cancellation_policy.card.with_out.desc',
    },
  },
};
